export UserIcon from '@material-ui/icons/ChildCare'
export UserList from './List'
export UserCreate from './Create'
export UserEdit from './Edit'
export UserQueries from './queries'
